import * as React from 'react';

const useGetAppointmentTypesForSelectedAgeGroup = (selectedAgeGroup, allAppointmentTypes)=>React.useMemo(()=>{
        if (selectedAgeGroup === 'ALL') {
            return allAppointmentTypes;
        }
        const appointmentTypes = allAppointmentTypes.filter(({ ageGroup  })=>{
            if (selectedAgeGroup === 'CHILD' && ageGroup === 'CHILD') {
                return true;
            }
            if (selectedAgeGroup === 'ADULT' && ageGroup === 'ADULT') {
                return true;
            }
            if (selectedAgeGroup === 'SENIOR' && ageGroup === 'SENIOR') {
                return true;
            }
            return false;
        });
        return appointmentTypes;
    }, [
        selectedAgeGroup,
        allAppointmentTypes
    ])
;

export { useGetAppointmentTypesForSelectedAgeGroup as default };
//# sourceMappingURL=useGetAppointmentTypesForSelectedAgeGroup.js.map
